import { useMemo } from 'react';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { usePoliceChartsDataContext } from './hooks/usePoliceChartsDataContext';

const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

const getMonthLabel = (mes) => {
    const monthIndex = parseInt(mes) - 1;
    const monthName = monthNames[monthIndex] || mes;
    return `${monthName}`;
};

export const ByCorporateMonth = () => {
    const { chartData } = usePoliceChartsDataContext();

    const { series, categories } = useMemo(() => {
        let monthData = chartData?.byCorporateMonth || [];
        
        if (!monthData.length) {
            return { series: [], categories: [] };
        }

        // Sort data chronologically by year and month
        monthData = [...monthData].sort((a, b) => {
            const yearDiff = parseInt(a.ano_estatistica) - parseInt(b.ano_estatistica);
            if (yearDiff !== 0) return yearDiff;
            return parseInt(a.mes_estatistica) - parseInt(b.mes_estatistica);
        });

        // Limit to 12 consecutive months (last 12)
        monthData = monthData.slice(-12);

        // Get all unique corporations
        const corporateSet = new Set();
        monthData.forEach(period => {
            period.corporacoes?.forEach(corporate => {
                corporateSet.add(corporate.corporacao);
            });
        });

        // Create series for each corporation
        const corporationSeries = Array.from(corporateSet).map(corporationName => {
            const data = monthData.map(period => {
                const corporationData = period.corporacoes?.find(b => b.corporacao === corporationName);
                return corporationData?.total || 0;
            });
            return {
                name: corporationName,
                data: data
            };
        });

        // Get month/year as categories
        const monthCategories = monthData.map(item => 
            getMonthLabel(item.mes_estatistica)
        );

        return {
            series: corporationSeries,
            categories: monthCategories
        };
    }, [chartData?.byCorporateMonth]);


    return (
        <SimpleBars
            title="Por Corporação (Mensal)"
            horizontal={true}
            subtitles={categories}
            series={series}
            height={420}
            showDataLabels={true}
            stacked
        />
    );
};
